import {h} from 'ui/Framework';

export default h('svg', {
  width: '46',
  height: '22',
  viewBox: '-1 -1 48 24',
  xmlns: 'http://www.w3.org/2000/svg'
}, [
  h('g', {
    fill: 'none',
    fillRule: 'evenodd'
  }, [
    h('g', {
      fill: '#21304A'
    }, [
      h('g', [
        h('path', {
          d: 'M9.436 21.15H7.42v-8.54L0 1.328h2.52l5.964 9.604 6.02-9.604h2.352L9.436 12.61v8.54zm9.184.505l-1.624-.532L25.48.823l1.596.56-8.456 20.272zm25.284-3.444h.056V1.327h2.016V21.15h-2.52L31.92 4.099h-.056V21.15h-2.016V1.327h2.52L43.904 18.21z'
        })
      ])
    ])
  ])
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/field-boolean.es6.js